import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  IconButton,
  ModalDialogNew,
  ModBox,
  Text,
  TextProps,
} from '@jfs/ui-new'
import { useState } from 'react'
import { ScrollView } from 'react-native-gesture-handler'
import { DateRangeSelector } from '../../comps/Filters/DateRangeSelector'
import { Colors } from '../../util/util'

interface DateFilterProps {
  showDateFilterComp: boolean
  selectedDateInfo: any
  updateSelectedFilterDateInfo: any
}

export const DateFilter = ({ showDateFilterComp, selectedDateInfo, updateSelectedFilterDateInfo }: DateFilterProps) => {
  const [filtersVisible, setFiltersVisible] = useState(false)
  const [intermidiateDateInfo, updateIntermidiateDateInfo] = useState(null)

  const invalidDate = () => {
    return !intermidiateDateInfo?.fromDate || !intermidiateDateInfo?.toDate
  }

  return (
    <>
      <ModBox
        show={showDateFilterComp}
        flexDirection={'row'}
        align={'center'}
        pl={10}
        underlayColor={'TRANSPARENT'}
        testID="show-filter"
        onPress={() => setFiltersVisible(true)}>
        <Box pr={5}>
          <Icon id={'FILTER2'} color={Colors.BLACK_14 as ColorOptions} size={16} />
        </Box>
        <Text
          fontFamily="JioType-Medium"
          fontSize={14}
          title="Filters"
          lineHeight={16}
          letterSpacing={-0.06}
          color={Colors.BLACK_14 as ColorOptions}
        />
      </ModBox>
      <ModBox show={filtersVisible}>
        <ModalDialogNew animate={true} show={true} type="bottom" backgroundColor="TRANSPARENT">
          <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
            <Box {...styles.container}>
              <Box {...styles.closeBox} flexDirection={'row'}>
                <Text textAlign="left" fontSize={24} fontFamily={'JioType-Black'} lineHeight={32} letterSpacing={-0.12}>
                  {'Filters'}
                </Text>
                <IconButton
                  size={24}
                  id="CLOSE"
                  testID="close-filter"
                  onPress={() => setFiltersVisible(false)}
                  color={'BLACK'}
                />
              </Box>
              <Box flexDirection={'row'}>
                <Box f={0.42} bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
                  <Box {...sectionStyles.sectionBox}>
                    <Text {...sectionStyles.sectionText}>{'By Date'}</Text>
                  </Box>
                </Box>
                <Box f={0.58} h={320}>
                  <ScrollView style={{ overflow: 'scroll' }}>
                    <DateRangeSelector
                      onDateRangeChange={(dateInfo) => {
                        console.log('htag dateInfo', dateInfo)
                        updateIntermidiateDateInfo(dateInfo)
                      }}
                      selectedDateInfo={selectedDateInfo}
                      selectedFilteredData={{ selectedDateInfo: selectedDateInfo }}
                    />
                  </ScrollView>
                </Box>
              </Box>
              <Box {...styles.buttonCon}>
                <Box
                  disabled={invalidDate()}
                  testID="apply-filter"
                  onPress={(args) => {
                    console.log('htag', intermidiateDateInfo)
                    updateSelectedFilterDateInfo(intermidiateDateInfo)
                    setFiltersVisible(false)
                  }}
                  width={148}
                  pv={16}
                  align={'center'}
                  justify={'center'}
                  underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
                  borderRadius={100}
                  bg={'PRIMARY'}
                  opacity={invalidDate() ? 0.5 : 1}>
                  <Text
                    title={'Apply'}
                    fontFamily={'JioType-Medium'}
                    fontSize={16}
                    letterSpacing={-0.08}
                    color={'WHITE'}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </ModalDialogNew>
      </ModBox>
    </>
  )
}

const sectionStyles = {
  sectionBox: {
    justify: 'center',
    paddingLeft: 24,
    pv: 16,
    underlayColor: 'LIGHTEST_GREY',
    backgroundColor: convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions,
    borderRightWidth: 2,
    borderRightColor: 'BLACK',
  } as BoxProps,
  sectionText: {
    color: Colors.PRIMARY,
    fontFamily: 'JioType-Bold',
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.07,
  } as TextProps,
}

export const styles = {
  container: {
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    backgroundColor: 'WHITE',
  } as BoxProps,
  closeBox: {
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'DISABLED_GREY',
    p: 24,
  } as BoxProps,
  filterItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'GREYISH_WHITE',
  } as BoxProps,
  filterItem: {
    flexDirection: 'row',
    alignItems: 'center',
    pv: 16,
    ph: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  inputContainer: {
    width: '100%',
    paddingHorizontal: 24,
    pv: 16,
  } as BoxProps,
  buttonCon: {
    justifyContent: 'space-around',
    position: 'relative',
    p: 24,
    borderTopWidth: 1,
    borderTopColor: 'DISABLED_GREY',
    flexDirection: 'row',
  } as BoxProps,
  line: {
    borderBottomWidth: 1,
    width: '100%',
    opacity: 0.1,
    marginTop: '10%',
  } as BoxProps,
}
